import React from 'react';
import { FreebetsUsageTable } from './FreebetsUsageTable';

export const FreebetsUsageList: React.FC = () => {
  return <FreebetsUsageTable />;
};
